import { DatePicker } from "@mui/lab";
import {
  AlertColor,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  MenuItem,
  Modal,
  TextField,
  Theme,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios, { AxiosResponse } from "axios";
import React, { useImperativeHandle, useMemo } from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Statement, StatementRecord } from "./StatementAccessories";
import { DropDownComboOption } from "../../../component/GenericFilter";
import { SnackBarMessage, SnackBarMessageProps } from "../../../component/SnackBarMessage";
import { GeneralDialog } from "../../../component/GeneralDialog";
import Title from "../../../component/Title";
import moment from "moment";
import { CommonProps } from "../../../component/MainContents";
import { CustomDropDown1 } from "../../../component/CustomDropDown1";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridCellParams, GridColumns, GridRowId, GridToolbarContainer } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../../component/CustomPagination";
import { Add, Search } from "@mui/icons-material";
import { FormatNumber, Pad } from "../../../../common/Formatter";
import { Customer } from "../../customers/CustomerAccessories";
import { BranchInfo } from "../../branches/BranchAccessories";
import { Bank } from "../../banks/BankAccessories";
import { renewToken } from "../../../../services/AuthService";
import { defaultBankName, defaultBankNameSS, defaultStatementRegions, defaultPaymentTerm } from "../../../../common/Constants";
import { OpenMode } from "../../../../common/Enums";
import { MonthNames } from "../../../../common/Constants";
import { StatementRecordFilter } from "../../../../models/classes/StatementRecordFilter";
import { StatementRecordSingle, StatementRecordSingleHandle } from "./StatementRecordSingle";
import { StatementViewer, StatementViewerHandle } from "./StatementViewer";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

export interface StatementSingleHandle {
  Initialise: (mode: OpenMode, statement: Statement) => void;
}

export function GetStatementRegion(statementNo: string) {
  return statementNo.substring(2, 4);
}

export const StatementSingle = React.forwardRef(
  (props: CommonProps, ref: React.Ref<StatementSingleHandle>) => {
    const style = { ...useStyles(), ...globalTheme() };

    const singleModalRef = React.useRef<StatementRecordSingleHandle>(null);
    const viewerModalRef = React.useRef<StatementViewerHandle>(null);

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const [hasError, setHasError] = React.useState(false);

    const [open, setOpen] = React.useState(false);
    const [openMode, setOpenMode] = React.useState<OpenMode>(OpenMode.NEW);
    const [model, setModel] = React.useState<Statement>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [region, setRegion] = React.useState<string>("");
    const [filteredCustomers, setFilteredCustomers] = React.useState<DropDownComboOption[]>([]);

    const [disableRegionDropDown, setDisableRegionDropDown] = React.useState<boolean>(true);
    const [disablePreviewButton, setDisablePreviewButton] = React.useState<boolean>(true);

    const [branchInfo, setBranchInfo] = React.useState<BranchInfo[]>([]);

    const [selectedCustomer, setSelectedCustomer] = React.useState<Customer>();
    const [customerAddress, setCustomerAddress] = React.useState<string>("");
    const [customerTel, setCustomerTel] = React.useState<string>("");
    const [customerFax, setCustomerFax] = React.useState<string>("");
    const [fromDate, setFromDate] = React.useState<Date>(new Date());
    const [toDate, setToDate] = React.useState<Date>(new Date());

    const [banks, setBanks] = React.useState<Bank[]>([]);
    const [selectedBankId, setSelectedBankId] = React.useState<number>(0);

    const [statementRegions, setStatementRegions] = React.useState<DropDownComboOption[]>([]);

    const [switchPageOnClose, setSwitchPageOnClose] = React.useState<boolean>(false);
    const [saved, setSaved] = React.useState<boolean>(false);

    function getBankId(bankName: string) {
      if (bankName == "")
        return 0;

      return banks.find(x => x.bankName == bankName)?.bankID ?? 0;
    }

    const bankPhone = useMemo(() => getBankPhone(selectedBankId), [selectedBankId]);
    function getBankPhone(id: number) {
      if (id == 0)
        return "";

      return banks.find(x => x.bankID == id)?.phone;
    }

    const bankAddress = useMemo(() => getBankAddress(selectedBankId), [selectedBankId]);
    function getBankAddress(id: number) {
      if (id == 0)
        return "";

      return banks.find(x => x.bankID == id)?.bankAddress;
    }

    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

    const [gridData, setGridData] = React.useState<StatementRecord[]>([]);

    const columnWidth25 = useMemo(() => GetColumnWidth(25, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth35 = useMemo(() => GetColumnWidth(35, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth40 = useMemo(() => GetColumnWidth(40, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth50 = useMemo(() => GetColumnWidth(50, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth55 = useMemo(() => GetColumnWidth(55, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth60 = useMemo(() => GetColumnWidth(60, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth68 = useMemo(() => GetColumnWidth(68, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth70 = useMemo(() => GetColumnWidth(70, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth80 = useMemo(() => GetColumnWidth(80, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth100 = useMemo(() => GetColumnWidth(100, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth120 = useMemo(() => GetColumnWidth(120, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth140 = useMemo(() => GetColumnWidth(160, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    function GetColumnWidth(width: number, isTiny: boolean, isSmall: boolean) {
      switch (width) {
        case 25:
          return isTiny ? 25 : (isSmall ? 30 : 35);
        case 35:
          return isTiny ? 35 : (isSmall ? 40 : 45);
        case 40:
          return isTiny ? 40 : (isSmall ? 45 : 55);
        case 50:
          return isTiny ? 50 : (isSmall ? 58 : 68);
        case 55:
          return isTiny ? 55 : (isSmall ? 70 : 80);
        case 60:
          return isTiny ? 60 : (isSmall ? 80 : 90);
        case 68:
          return isTiny ? 68 : (isSmall ? 85 : 100);
        case 70:
          return isTiny ? 70 : (isSmall ? 90 : 105);
        case 80:
          return isTiny ? 80 : (isSmall ? 100 : 110);
        case 100:
          return isTiny ? 100 : (isSmall ? 125 : 150);
        case 120:
          return isTiny ? 120 : (isSmall ? 155 : 190);
        case 160:
          return isTiny ? 160 : (isSmall ? 210 : 270);
        default:
          return width;
      }
    }

    //Grid columns
    const columns: GridColumns = [
      { 
        field: 'selected', headerName: '', 
        width: columnWidth35, minWidth: columnWidth35, 
        renderCell: (params: GridCellParams) => (
          <Checkbox checked={params.value} 
            sx={{ minHeight: 0, minWidth: 0, padding: 0 }}
            onChange={(e) => {
						onSelectionChanged(params, e.target.checked);	
					}}
          />
        )
      },
      { 
        field: 'paid', headerName: 'Paid', 
        width: columnWidth35, minWidth: columnWidth35, 
        renderCell: (params: GridCellParams) => (
          <Checkbox checked={params.value} 
            sx={{ minHeight: 0, minWidth: 0, padding: 0 }}
            onChange={(e) => {
						onPaidChanged(params, e.target.checked);	
					}}
          />
        )
      },
      { 
        field: 'customerID', headerName: 'Customer', flex: 1, 
        type: 'string', editable: false, 
        valueFormatter: (param) => {
          return props.customers.find(x => x.value  === (param.value + (model?.custLangID ?? 1) * 100000).toString())?.name
        }
      },
      { 
        field: 'invoiceDate', headerName: 'Invoice Date', 
        width: columnWidth100, minWidth: columnWidth100, 
        renderCell: (params: GridCellParams) => (
          <TextField variant="standard" value={moment(params.value).format('YYYY/MM/DD')} InputProps={{ disableUnderline: true }}/>
        )
      },
      {
        field: 'invoiceNo', headerName: 'Invoice No.', type: 'string', editable: false,
        width: columnWidth120, minWidth: columnWidth120, 
      },
      {
        field: 'poNo', headerName: 'PO No.', flex: 4, type: 'string', editable: false,
      },
      { field: 'currency', headerName: 'CCY', disableColumnMenu: true, sortable: false, width: columnWidth50, minWidth: columnWidth50, type: 'string' },
      {
        field: 'amount', headerName: 'Amount', disableColumnMenu: true, sortable: false, 
        width: columnWidth100, minWidth: columnWidth100, 
        type: 'number', editable: true,
        valueFormatter: (param) => FormatNumber(param.value, 2),
        cellClassName: style.NumberTextField
      }
    ];

    const [searchData, setSearchData] = React.useState<any>({
      pageSize: 10,
    });

    const selectedData = React.useRef<StatementRecord[]>([]);

    function onSelectionChanged(params: GridCellParams, checked: boolean) {
      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.recordID === params.row.id);
      tmpData[index].selected = checked;
      if (checked)
        tmpData[index].statementNo = model?.statementNo ?? "";

      setGridData(tmpData);
    }

    function onPaidChanged(params: GridCellParams, checked: boolean) {
      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.recordID === params.row.id);
      tmpData[index].paid = checked;
      setGridData(tmpData);
    }

    function CustomToolbar() {
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              key="fromDate"
              label="From"
              inputFormat="yyyy/MM/dd"
              mask="____/__/__"
              value={fromDate}
              onChange={(newValue) => {
                setFromDate(newValue ?? new Date());
                SearchStatementRecords(model?.statementNo ?? "", newValue ?? new Date(), toDate, selectedCustomer?.customerId ?? 0);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
          <div style={{ width: 10 }}></div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              key="toDate"
              label="To"
              inputFormat="yyyy/MM/dd"
              mask="____/__/__"
              value={toDate}
              onChange={(newValue) => {
                setToDate(newValue ?? new Date());
                SearchStatementRecords(model?.statementNo ?? "", fromDate, newValue ?? new Date(), selectedCustomer?.customerId ?? 0);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
          <div style={{ width: 10 }}></div>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Search />} onClick={() => SearchStatementRecords(model?.statementNo ?? "", fromDate, toDate, selectedCustomer?.customerId ?? 0)}>Search</Button>
          <div style={{ width: 10 }}></div>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Add />} onClick={() => AddStatementRecords()}>Add</Button>
        </GridToolbarContainer>
      );
    }

    function AddStatementRecords() {
      if (model)
      {
        let statementRecord: StatementRecord = {
          id: 0,
          recordID: 0,
          statementNo: "",
          customerID: model?.customerID,
          custLangID: model?.custLangID,
          invoiceDate: moment(new Date()).format(),
          invoiceNo: "",
          poNo: "",
          currency: "JPY",
          amount: 0,
          paid: false,
          region: "HK",
          selected: false
        }
        singleModalRef.current?.Initialise(OpenMode.NEW, statementRecord);
      }
    }

    function SearchStatementRecords(statementNo: string, from: Date, to: Date, custId: number) {
      setLoading(true);
      let filter = new StatementRecordFilter({
        From: moment(from).format(),
        To: moment(to).format(),
        CustomerID: custId,
        StatementNo: statementNo
      });

      axios.post<StatementRecord[]>('Api/V1/Statement/StatementRecord/Search', filter, {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          result.data.forEach(i => {
            i.id = i.recordID;
            if (i.statementNo==filter.StatementNo)
            {
              i.selected = true;
            }
          });

          setGridData(result.data.sort((a, b) => {
            if (a.selected > b.selected) { return -1; }
            if (a.selected < b.selected) { return 1; }
            if (a.paid < b.paid) { return -1; }
            if (a.paid > b.paid) { return 1; }
            if (a.invoiceDate > b.invoiceDate) { return -1; }
            if (a.invoiceDate < b.invoiceDate) { return 1; }
            if (a.invoiceDate === b.invoiceDate)
            {
              if (a.statementNo > b.statementNo) { return -1; }
              if (a.statementNo < b.statementNo) { return 1; }
            }
            return 0;					
          }));
          setLoading(false);
        },
          (error) => {
            setGridData([]);
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });
    }

    //Dialogs and snacks
    const hasChanges = React.useRef<boolean>(false);
    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }


    useImperativeHandle(ref, () => ({
      Initialise(mode: OpenMode, statement: Statement) {
        setOpen(true);
        setSaved(false);
        renewToken();

        hasChanges.current = false;
        setOpenMode(mode);
        // setCurrency(invoice.currency);
        let region = GetStatementRegion(statement.statementNo);
        setRegion(region);

        setStatementRegions(props.regions.filter(function(x) {
          return defaultStatementRegions.indexOf(x.value) > -1;
        }));
        
        setDisableRegionDropDown(false);
        setDisablePreviewButton(true);

        var lastMonthFirstDdate = new Date();
        lastMonthFirstDdate.setDate(1);
        lastMonthFirstDdate.setMonth(lastMonthFirstDdate.getMonth()-1);
        setFromDate(lastMonthFirstDdate);

        var thisMonthFirstDdate = new Date();
        thisMonthFirstDdate.setDate(1);
        setToDate(thisMonthFirstDdate);

        axios.all([
          axios.get<any[]>(`Api/V1/Bank`, {
              headers: {
                  'Content-Encoding': 'gzip'
              }
          }),
          axios.get<any[]>(`Api/V1/Branch`, {
            headers: {
              'Content-Encoding': 'gzip'
            }
          })
        ]).then(axios.spread((...responses) => {
          const bankResult: AxiosResponse<Bank[]> = responses[0];
          const branchResult: AxiosResponse<BranchInfo[]> = responses[1];
          let bankName = "";

          if (region == "SS")
          {
            let banksByRegion = bankResult.data.filter(x => x.region == region);
            setBanks(banksByRegion);
            if (banksByRegion.length > 0)
            {
              let bankId = banksByRegion.find(x => x.bankName == statement.bankName)?.bankID ?? banksByRegion[0].bankID;
              bankName = banksByRegion.find(x => x.bankID == bankId)?.bankName ?? defaultBankNameSS;
              setSelectedBankId(bankId);
            }
          }
          else
          {
            let banksByRegion = bankResult.data.filter(x => x.region != "SS");
            setBanks(banksByRegion);
            if (banksByRegion.length > 0)
            {
              let bankId = banksByRegion.find(x => x.bankName == statement.bankName)?.bankID ?? banksByRegion[0].bankID;
              bankName = banksByRegion.find(x => x.bankID == bankId)?.bankName ?? defaultBankName;
              setSelectedBankId(banksByRegion.find(x => x.bankName == statement.bankName)?.bankID ?? banksByRegion[0].bankID);
            }
          }
          setBranchInfo(branchResult.data);
          
          FilterCustomersByLanguage([0]); //Always show customer names of any language
          
          if (mode === OpenMode.NEW)
          {
            setCustomerAddress("");
            setCustomerTel("");
            setCustomerFax("");
    
          }
          else if (mode === OpenMode.EDIT)
          {
            setDisableRegionDropDown(true);
            setDisablePreviewButton(false);
            LoadCustomerInfo(statement.customerID, statement.custLangID, statement.customerName, true);
          } 

          let temp: any = { ...model };
          temp = statement;
          if (props.paymentTerms.findIndex(x => x.name === temp.paymentTerm) > -1)
            temp.paymentTerm = temp.paymentTerm;
          else
            temp.paymentTerm = "30 days after delivery";
          temp.staff = "";
          temp.bankName = bankName;
  
          setModel(temp);
  
          setGridData(statement.statementRecords.sort((a, b) => {
            if (a.selected > b.selected) { return -1; }
            if (a.selected < b.selected) { return 1; }
            if (a.paid < b.paid) { return -1; }
            if (a.paid > b.paid) { return 1; }
            if (a.invoiceDate > b.invoiceDate) { return -1; }
            if (a.invoiceDate < b.invoiceDate) { return 1; }
            if (a.invoiceDate === b.invoiceDate)
            {
              if (a.statementNo > b.statementNo) { return -1; }
              if (a.statementNo < b.statementNo) { return 1; }
            }
            return 0;					
          }));

          setLoading(false);
        })).catch((error) => {
          console.log(error);
          setBanks([]);
          setBranchInfo([]);
          setHasError(true);
          setLoading(false);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        })
    },
    }));

    function closeModal() {
      setDialogOpen(false);
      setOpen(false);
      props.onClose(false, model!);
    }

    function closeModalCheck(keepOpen: boolean) {
      if (hasChanges.current) {
        setDialogOpen(true);
      } else {
        setDialogOpen(false);
        setOpen(keepOpen);
        props.onClose(switchPageOnClose && saved, model!);
      }
    }

    function isSaveValid(showWarning: boolean) {
      let proceed = true;
      let warning = "";
      let noOfLines = 0;
      if (model) {
        if (model.customerName === "" || model.customerID === 0) {
          warning += "Please select a customer\r\n"
          noOfLines++;
          proceed = false
        }

        if (!proceed && showWarning) {
          showSnackBar(warning, "", "warning");
        }
      }

      return proceed;
    }

    function Update(
      propertyName: string,
      propertyValue: any,
      validationRegex?: RegExp
    ) {
      let proceed = true;

      if (validationRegex !== undefined) {
        proceed = validationRegex.test(propertyValue);
      }

      if (proceed) {
        let temp: any = { ...model };

        if (temp[propertyName] != propertyValue)
        {
          hasChanges.current = true;
          temp[propertyName] = propertyValue ?? null;
          setModel(temp);
        }
      }
    }

    function CustomerChanged(newCustomer: any) {
      if (newCustomer) {
        let custId = newCustomer.value % 100000;
        let custLangId = Math.trunc(newCustomer.value / 100000);
        LoadCustomerInfo(custId, custLangId, newCustomer.name, false);
        SearchStatementRecords(model?.statementNo ?? "", fromDate, toDate, custId);
      }
    }

    function LoadCustomerInfo(customerId: number, custLangId: number, custName: string, isInit: boolean)
    {
      axios.get<Customer>('Api/V1/Customer/' + customerId.toString(), {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          if (result.data) 
          {
            setSelectedCustomer(result.data)

            if (!isInit)
            {
              hasChanges.current = true;
              let temp: any = { ...model };
              temp.customerID = customerId;
              temp.customerName = custName;
              temp.custLangID = custLangId;
              temp.attention = result.data.contactPerson;
              if (props.paymentTerms.findIndex(x => x.name === result.data.paymentTerm) > -1)
                temp.paymentTerm = result.data.paymentTerm;
              else
                temp.paymentTerm = defaultPaymentTerm;
  
              setModel(temp);
            }
            setCustomerAddress(result.data.deliveryAddress ?? "");
            setCustomerTel(result.data.phone1 ?? "");
            setCustomerFax(result.data.fax1 ?? "");
          }
        },
          (error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });        
    }

    function GetBankIdByName(bankName: string) {
      return banks.find(x => x.bankName == bankName)?.bankID ?? 1;
    }

    function FilterCustomersByLanguage(langIds: number[]) {
      let temp: DropDownComboOption[] = props.customers;
      let result: DropDownComboOption[] = [];
      if (langIds.findIndex( x => x === 0) > -1)
      {
        setFilteredCustomers(props.customers);
      } 
      else
      {
        langIds.forEach((id) => {
          result = result.concat(Object.values(temp).filter(c => Math.trunc(parseInt(c.value) / 100000) === id));
        });
        setFilteredCustomers(result);
      }
    }

    function RegionChanged(region: string) {
      hasChanges.current = true;

      axios.get<any[]>(`Api/V1/Branch`, {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          setBranchInfo(result.data);

          let branchSelected: BranchInfo | undefined = result.data.find(b => b.region === region);
          setRegion(region);
          if (branchSelected)
          {
            let temp: any = { ...model };
            let newStatementNo: string = "";
      
            let currentMonth = new Date().getMonth();
            let newStatmentIndex = branchSelected.statementNo;
            if (currentMonth != branchSelected.statementMonth - 1)
            {
              newStatmentIndex = 1;
            }
            let monthPart: string;
            monthPart = (new Date().getFullYear()).toString().substring(2,4) + MonthNames[currentMonth].toUpperCase().substring(0,3);
      
            newStatementNo = "ME" + branchSelected.region + monthPart + Pad(newStatmentIndex, 4);
    
            temp["statementNo"] = newStatementNo;
    
            setModel(temp);
            SearchStatementRecords(newStatementNo, fromDate, toDate, selectedCustomer?.customerId ?? 0);
          }
        },
          (error) => {
            setBranchInfo([]);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });
    }

    function getStatementNo() {
      let branchSelected: BranchInfo | undefined = branchInfo.find(b => b.region === region);
      let newStatementNo: string = "";

      let monthPart: string;
      if (branchSelected)
      {
        monthPart = (new Date().getFullYear()).toString().substring(2,4) + MonthNames[branchSelected.statementMonth].toUpperCase().substring(0,3);
        newStatementNo = "ME" + branchSelected.region + monthPart + Pad(branchSelected.statementNo, 4);
      }

      return newStatementNo;
    }

    function SaveChanges(
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      close: boolean
    ) {
      if (isSaveValid(true)) {
        event.preventDefault();
        event.stopPropagation();

        let m = model;
        if (m)
        {
          m.attention = m.attention == null ? "" : m.attention;
          m.cc = m.cc == null ? "" : m.cc;
          m.bankAddress = bankAddress ?? "";
          m.bankPhone = bankPhone ?? "";
          m.bankAccount = "";
          m.statementRecords = gridData.filter(x => x.selected);
          m.phone1 = "";
          m.phone2 = "";
          m.fax1 = "";
          m.fax2 = "";
          m.address = "";
          setModel(m);
        }
  
        if (openMode === OpenMode.EDIT)
        {
          axios.put<Statement>('Api/V1/Statement/', m).then(
            (result) => {
              let temp: any = { ...model };
              temp = result.data;
              temp.staff = ""; //staff cannot be null when save
              setModel(temp);
  
              showSnackBar("Statement saved successfully.", "", "success");
              hasChanges.current = false;
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        } 
        else
        {
          axios.post<Statement>('Api/V1/Statement/', m).then(
            (result) => {
              let temp: any = { ...model };
              temp = result.data;
              temp.staff = ""; //staff cannot be null when save
              setModel(temp);
              if (result.data.statementRecords && result.data.statementRecords.length > 0)
              {
                let tmpGridData = [...result.data.statementRecords];
                tmpGridData.forEach(x => x.id = x.recordID);
                setGridData(tmpGridData.sort((a, b) => {
                  if (a.selected > b.selected) { return -1; }
                  if (a.selected < b.selected) { return 1; }
                  if (a.paid < b.paid) { return -1; }
                  if (a.paid > b.paid) { return 1; }
                  if (a.invoiceDate > b.invoiceDate) { return -1; }
                  if (a.invoiceDate < b.invoiceDate) { return 1; }
                  if (a.invoiceDate === b.invoiceDate)
                  {
                    if (a.statementNo > b.statementNo) { return -1; }
                    if (a.statementNo < b.statementNo) { return 1; }
                  }
                  return 0;					
                }));
              }
  
              showSnackBar("Statement created successfully.", "", "success");
              hasChanges.current = false;
              setSaved(true);
              setDisableRegionDropDown(true);
              setDisablePreviewButton(false);
              setOpenMode(OpenMode.EDIT);
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        }
      }
    }

    function Preview(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
      let m = model;
       if (m)
         viewerModalRef.current?.Initialise(m.statementNo);
    }

    return (
      <div>
        <Modal open={open} onClose={() => closeModalCheck(true)}>
          <div className={style.ModalMain}>
            {model && !loading ? (
              <div className={style.ModalBody}>
                <Title pageTitle="Statement" />
                <div className={style.ModalContent}>
                  <div className={style.ModalFields}>
                    <CustomDropDown1 className={style.ModalContentField}
                      dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                      firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")}
                      firstTextBoxMinWidth={tinyScreen ? "174px" : (smallScreen ? "260px" : "375px")}
                      dropDownBoxId="region-dropdown" dropDownBoxLabel="Region" dropDownBoxDisabled={disableRegionDropDown}
                      firstTextBoxLabel="Statement No" firstTextBoxName="txtStatementNo"
                      dropDownBoxValue={region} dropDownBoxOptions={props.regions}
                      firstTextBoxValue={model.statementNo}
                      onSelectionChanged={RegionChanged} />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          key="date"
                          label="Date"
                          inputFormat="yyyy/MM/dd"
                          mask="____/__/__"
                          value={Date.parse(model.statementDate)}
                          onChange={(newValue) => Update("statementDate", moment(newValue).format())}
                          renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} size="small" />}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className={style.ModalFields}>
                    <Autocomplete className={style.ModalContentField}
                      limitTags={2}
                      onChange={(e, selected) => CustomerChanged(selected)}
                      options={filteredCustomers}
                      getOptionLabel={(option: DropDownComboOption) => option.name}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.value}>
                            {option.name}
                          </li>
                        );
                      }}
                      value={filteredCustomers.find(s => s.value === (model.customerID + model.custLangID * 100000).toString()) || null}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={"Customer"}
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                    <TextField className={style.ModalContentField}
                      value={customerAddress}
                      label="Company Address"
                      size="small"
                      multiline
                      rows={3}
                      inputProps={
                        { readOnly: true, }
                      }
                      fullWidth
                    />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={customerTel}
                        label="Telephone"
                        size="small"
                        inputProps={
                          { readOnly: true, }
                        }
                        fullWidth                      
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={customerFax}
                        label="Fax"
                        size="small"
                        inputProps={
                          { readOnly: true, }
                        }
                        fullWidth                      
                        />
                  </div>
                  <TextField className={style.ModalContentField}
                      value={model.remark}
                      label="Remark"
                      onChange={(e) => Update("remark", e.target.value.slice(0,200))}
                      size="small"
                      multiline
                      rows={3}
                      fullWidth
                    />
                </div>
                <div className={style.ModalFields}>
                  <TextField className={style.ModalContentField}
                    value={model.attention}
                    label="Attention"
                    onChange={(e) => Update("attention", e.target.value.slice(0,30))}
                    size="small"
                    fullWidth
                  />
                  <TextField className={style.ModalContentField}
                    value={model.cc}
                    label="CC"
                    onChange={(e) => Update("cc", e.target.value.slice(0,30))}
                    size="small"
                    fullWidth
                  />
                </div>
                <div className={style.PageContent} style={{ minHeight: "290px" }}>
                    <DataGridPro
                      headerHeight={tinyScreen ? 28 : (smallScreen ? 32 : 36)}
                      rowHeight={tinyScreen ? 24 : (smallScreen ? 28 : 32)}
                      getRowId={(row) => row.recordID}
                      rows={gridData}
                      columns={columns}
                      pageSize={searchData.pageSize}
                      onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                      pagination
                      rowsPerPageOptions={[10, 20, 40]}
                      loading={loading}
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomTablePagination
                      }}
                      componentsProps={{
                        footer: { rowsPerPageOptions: [10, 20, 40] }
                      }}
                      selectionModel = {selectionModel}
                      onSelectionModelChange={(selections) => {
                        setSelectionModel(selections)
                        const ids = new Set(selections);
                        const selectedRows = gridData.filter((row) => ids.has(row.recordID));
                        selectedData.current = selectedRows;
                      }}
                      disableSelectionOnClick={true}
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <TextField className={style.ModalContentField}
                      id="bank"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      value={model.bankName}
                      onChange={(e) => {
                        setSelectedBankId(GetBankIdByName(e.target.value));
                        let temp: any = { ...model };
                        temp["bankName"] = e.target.value ?? null;
                        temp["bankAddress"] = banks.find(x => x.bankID == getBankId(e.target.value))?.bankAddress;
                        setModel(temp);
                      }}
                      select
                      label="Bank Name"
                      size="small"
                      fullWidth
                    >
                      {banks.map((item) => (
                        <MenuItem key={item.bankID} value={item.bankName}>
                          {item.bankName}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField className={style.ModalContentField}
                      value={bankPhone}
                      label="Bank Phone"
                      onChange={(e) => Update("bankPhone", e.target.value.slice(0,25))}
                      size="small"
                      fullWidth
                    />
                    <TextField className={style.ModalContentField}
                      value={bankAddress}
                      label="Bank Address"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      multiline={true}
                      rows={2}
                      size="small"
                      fullWidth
                    />
                    <TextField className={style.ModalContentField}
                      id="payment-term"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      value={model.paymentTerm}
                      onChange={(e) => Update("paymentTerm", e.target.value)}
                      select
                      label="Payment Term"
                      size="small"
                      fullWidth
                    >
                      {props.paymentTerms.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </div>

                <div className={style.ModalFooter}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    onClick={(e) => SaveChanges(e, false)}
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    disabled={disablePreviewButton}
                    onClick={(e) => Preview(e)}
                  >
                    Preview
                  </Button>
                  <Button
                    variant="contained"
                    className={style.margin}
                    onClick={(e) => closeModalCheck(false)}
                  >
                    Close
                  </Button>
                </div>

              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" />
              </div>
            )}
          </div>
        </Modal>

        <StatementRecordSingle
          ref={singleModalRef}
          customers={props.customers}
          regions={props.regions}
          paymentTerms={[]}
          endUsers={[]} 
          sales={[]} 
          deliveryMethods={[]} 
          currencies={props.currencies}
          onClose={(saved: boolean, statementRecord: StatementRecord) => {
            if (model)
              SearchStatementRecords(model.statementNo ?? "", fromDate, toDate, selectedCustomer?.customerId ?? 0);
				} } />

        <SnackBarMessage {...snackSettings} />

        <GeneralDialog
          title={"Save Changes?"}
          message={
            "Changes have been made, did you want to save before closing?"
          }
          open={dialogOpen}
          options={[
            {
              text: "Save",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => SaveChanges(event, true),
              color: "secondary",
              variant: "contained",
            },
            {
              text: "No",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => closeModal(),
              color: "primary",
              variant: "contained",
            },
          ]}
        />

        <StatementViewer ref={viewerModalRef} onClose={()=>{}}/>

      </div>
    );


  }

);
